import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: 'ri-dashboard-line' },
  { to: '/admin/bookings', label: 'Bookings', icon: 'ri-calendar-check-line' },
  { to: '/admin/clients', label: 'Clients', icon: 'ri-user-star-line' },
  { to: '/admin/custom-packages', label: 'Custom Packages', icon: 'ri-price-tag-3-line' },
  { to: '/admin/contacts', label: 'Contacts', icon: 'ri-message-3-line' },
  { to: '/admin/reviews', label: 'Reviews', icon: 'ri-star-line' },
  { to: '/admin/settings', label: 'Settings', icon: 'ri-settings-3-line' },
];

export default function AdminLayout({ children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <img
                src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w"
                alt="Logo"
                className="h-10 w-10"
              />
              <h1 className="text-xl font-bold text-gray-900">Admin Dashboard</h1>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/" className="text-gray-600 hover:text-gray-900" target="_blank">
                <i className="ri-external-link-line"></i> View Site
              </Link>
              <button
                onClick={handleLogout}
                data-testid="admin-logout-btn"
                className="text-red-600 hover:text-red-700"
              >
                <i className="ri-logout-box-line"></i> Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar + Content */}
      <div className="flex">
        <div className="w-64 bg-white min-h-[calc(100vh-4rem)] shadow-sm shrink-0">
          <nav className="p-4 space-y-2">
            {NAV_ITEMS.map((item) => {
              const active = pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`sidebar-${item.to.replace(/^\//, '').replace(/\//g, '-')}`}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-medium transition-colors ${
                    active
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <i className={`${item.icon} text-xl`}></i>
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="flex-1 p-8 overflow-x-auto">{children}</div>
      </div>
    </div>
  );
}
